module.exports = __webpack_public_path__ + "static/media/csv_up_orange.205d7d8b.svg";